import {
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  TemplateRef,
} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ChangeRequestConstants } from '../../../change-request/change-request.constants';
import { PanelListConstants } from '../../constants/panel-list-constants';
import { PanelList } from '../../models/panel-list';
import { MessageConstants } from '../../constants/message-constants';
import { DefaultFilter } from '../../models/panel-list/default-filter';
import { FilterAndSortDetails } from '../../models/filter-sort-details';
import { PanelCardView } from '../../enums/panelCardView';
import { PanelListPersistenceService } from '../../services/panel-list-persistence.service';

//host elements for the panel list
@Component({
  selector: 'app-panel-list',
  templateUrl: './panel-list.component.html',
  styleUrls: ['./panel-list.component.scss'],
})
export class PanelListComponent implements OnInit, OnChanges {
  @Input() panelList: PanelList = {
    lists: undefined,
    enableFilter: false,
    enableSort: false,
    enableSelection: false,
    clearSelection: false,
    enableToggling: false,
    isCheckBoxContainsDisable: false,
    enablePanelCardClick: false,
    enablePanelHighLight: false,
    enablePanelCardView:false,
    enableAssignmentView:false,
    enableWhereAmIUsedView:false
  };
  @Input() showLoader: boolean = false;
  @Input() noResultFound: boolean = false;
  @Input() ifAdditionalItems: boolean = false;
  @Input() isExportButtonAvailable:boolean=false;
  @Input() defaultFiltersSelected: DefaultFilter[] = [];
  @Input() standardFilterCount: number = PanelListConstants.StandardFilterLength; // input Parameter for minimum no of filter in 1st row 
  @Output() selectedItems = new EventEmitter();
  @Output() panelCardClickEvent = new EventEmitter();
  @Output() exportExcelEvent = new EventEmitter();
  @Output() panelCardViewEvent = new EventEmitter();
  @Output() panelCardViewTypeEvent = new EventEmitter<PanelCardView>();
  @Output() assignmentViewPanelList = new EventEmitter<MenuItem>();
  @Output() defaultViewPanelList = new EventEmitter<MenuItem>();
  selectedCards: any = [];
  @ContentChildren(TemplateRef) templateRef!: QueryList<TemplateRef<any>>;
  filterItems: any[] = [];
  sortItems: MenuItem[] = [];
  columns: MenuItem[] = [];
  serviceData: any[] = [];
  selectedFilterItems: Array<any[]> = [];
  filterKey: any = null;
  selectAll: boolean[] = [];
  selectAllItems: boolean = false;
  isSelectAllCheckBox = false;
  isCardToggleable: boolean = false;
  moreFilters: boolean = false;
  hideFilters: boolean = false;
  noFilter!: boolean;
  additionalFilters: any[] = [];
  allFilters: any[] = [];
  isMoreFilters!: boolean;
  populateAfterClickOnMoreFilter!: boolean;
  filteredItems = [];
  filteredData: any[] = [];
  isSelectAllDisabled = false;
  filterItemsCount = 0;
  disabledCheckBoxToolTipMessage = ''; //TO DO
  parentSelection = false;
  activeIndex: number = -1;
  noResultStatus = PanelListConstants.NoResultStatus;
  noResultMessage = PanelListConstants.NoResultMessage;
  noResultSubTitle = PanelListConstants.NoResultSubTitle;
  noResultDisplayButtons = PanelListConstants.NoResultDisplayButtons
  selectedDefaulFilterIndex: number | undefined = -1;
  filterAndSortDetails! : FilterAndSortDetails;
    label:string= '';
    icon:string='icon-dots-vertical';
    compact:boolean= true;
    stroked:boolean= false;
    disabled:boolean= false;
    items:any;

    
  
  constructor(private panelListPersistenceService : PanelListPersistenceService) { }
  ngOnInit(): void {
    this.serviceData = this.panelList.lists;
    this.setMenuItems();
    this.setSelectAllCheckBox();
    this.getSortData();
    this.filterAndSortDetails = this.getDefaultFilterAndSortDetails();
    this.setIcons();
  }

  setIcons(){
    this.panelListPersistenceService.panelListView$.subscribe(value=> {
      this.setViewIcon(value);
      this.clearViewIcon(value)
    })
  }

  setViewIcon(value : number){
    if(this.items === undefined || this.items.length === 0) return;
    let defaultView = this.items.find((a : MenuItem)=>a.label == PanelListConstants.DefaultView)
    let assignmentView = this.items.find((a : MenuItem)=>a.label == PanelListConstants.AssignmentView)
    let whereAmIUsedView = this.items.find((a : MenuItem)=>a.label == PanelListConstants.WhereAmIUsedView)
    switch(value){
      case PanelCardView.DefaultView:
        if (defaultView) {
        defaultView.styleClass = PanelListConstants.SelectedMenuItemStyleClass
        defaultView.icon = PanelListConstants.SelectedMenuItemIcon
        }
        break;

      case PanelCardView.AssignmentView:
        if (assignmentView) {
        assignmentView.styleClass = PanelListConstants.SelectedMenuItemStyleClass
        assignmentView.icon = PanelListConstants.SelectedMenuItemIcon
        }
        break;
      case PanelCardView.WhereAmIUsedView:
        if (whereAmIUsedView) {
        whereAmIUsedView.styleClass = PanelListConstants.SelectedMenuItemStyleClass
        whereAmIUsedView.icon = PanelListConstants.SelectedMenuItemIcon
        }
        break;
    }
  }

  clearViewIcon(value : number){
    let defaultView = this.items.find((a : MenuItem)=>a.label == PanelListConstants.DefaultView)
    let assignmentView = this.items.find((a : MenuItem)=>a.label == PanelListConstants.AssignmentView)
    let whereAmIUsedView = this.items.find((a : MenuItem)=>a.label == PanelListConstants.WhereAmIUsedView)
    switch(value){
      case PanelCardView.DefaultView:
        if(this.panelList.enableWhereAmIUsedView){
          whereAmIUsedView.styleClass = PanelListConstants.EmptyString
          whereAmIUsedView.icon = PanelListConstants.EmptyString  
        }
        if(this.panelList.enableAssignmentView){
          assignmentView.styleClass = PanelListConstants.EmptyString
          assignmentView.icon = PanelListConstants.EmptyString
        }
        break;
      case PanelCardView.AssignmentView:
      case PanelCardView.WhereAmIUsedView:
        defaultView.styleClass = PanelListConstants.EmptyString
        defaultView.icon = PanelListConstants.EmptyString
        break;
    }
  }


  setMenuItems(){
    this.items = [];
    if(this.panelList.enableExport){
      this.items.push({
        label:'Export',
        icon:'fa fa-file-excel',
        styleClass:'p-menuitem-compact',
        command: () =>this.exportDataToExcel() ,
        tooltip:"Export Data"
      });
    }

    if(this.panelList.enableToggling){
      this.items.push({
        label:'Expand All',
          icon:'fa fa-plus',
          styleClass:'p-menuitem-compact',
          command: () =>this.expandAll() ,
          tooltip:"Expand All"
      });
      this.items.push({
        label:'Collapse All',
          icon:'fa fa-minus',
          styleClass:'p-menuitem-compact',
          command: () =>this.collapseAll() ,
          tooltip:"Collapse All"
      });
    }

    if(this.panelList.enablePanelCardView){
      this.items.push({
        separator : true,
      })
      this.items.push({
        label:'Default View',
        styleClass:'p-menuitem-compact',
        command: () =>this.defaultView() ,
        tooltip:"Default View"
      });
      if(this.panelList.enableAssignmentView){
        this.items.push({
          label:'Assignment View',
          styleClass:'p-menuitem-compact',
          command: () =>this.assignmentView() ,
          tooltip:"Assignment View"
        });
      }

      if(this.panelList.enableWhereAmIUsedView){
        this.items.push({
          label:'Where Am I Used View',
          styleClass:'p-menuitem-compact',
          command: () =>this.whereAmIUsedView() ,
          tooltip:"Where Am I Used View"
        });
      }

    }
  }

  defaultView(){
    this.panelCardViewTypeEvent.emit(PanelCardView.DefaultView);
    this.panelCardViewEvent.emit();
    this.panelListPersistenceService.updatePanelListView(PanelCardView.DefaultView);
  }

  assignmentView(){
    this.panelCardViewTypeEvent.emit(PanelCardView.AssignmentView);
    this.panelCardViewEvent.emit();
    this.panelListPersistenceService.updatePanelListView(PanelCardView.AssignmentView);
  }

  whereAmIUsedView(){
    this.panelCardViewTypeEvent.emit(PanelCardView.WhereAmIUsedView);
    this.panelCardViewEvent.emit();
    this.panelListPersistenceService.updatePanelListView(PanelCardView.WhereAmIUsedView);
  }
  

  intilizeFiltersData() {
    this.parentSelection = false;
    this.serviceData = this.panelList.lists;
    this.getPanelToggleCondition();
    this.selectedFilterItems = [];
    this.getFiltersData();
    this.getAdditionalFiltersData();
    this.filterAndSortDetails = this.getDefaultFilterAndSortDetails();
    if (this.defaultFiltersSelected.length != 0) {
      this.defaultFiltersSelected.forEach(filter => {
        this.setDefaultFilters(filter.filterFieldName, filter.filterValues);
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.panelList.clearSelection == true) {
      this.clearPanelItems();
      this.panelList.clearSelection = false;
    }
    if (this.panelList.isCheckBoxContainsDisable == true) {
      this.isSelectAllCheckBox = false;
    }
    this.intilizeFiltersData();
  }

  clearPanelItems() {
    this.selectAll = [];
    this.selectedCards = [];
    this.selectedItems.emit(this.selectedCards);
    this.serviceData = this.panelList.lists;
  }  

  setDefaultFilters(filterFieldName: string, filterValue: string[]) {
    this.selectedDefaulFilterIndex = this.panelList.filters?.findIndex(object => {
      return object.filterFieldName === filterFieldName;
    });
    if(this.selectedDefaulFilterIndex != undefined) {
      this.selectedFilterItems[this.selectedDefaulFilterIndex] = filterValue;    
    this.applyFilter(filterFieldName, this.selectedDefaulFilterIndex);
    }
    
  }

  applyFilter(filterColumn: any, index: any) {
    this.noFilter = true;
    let latestFilteredItems: any[] = [];
    if ((filterColumn != null && index != null
      && this.selectedFilterItems[index] != undefined
      && this.selectedFilterItems[index].length > 0) || this.filterKey != '') {
      this.noFilter = false;
      latestFilteredItems = this.filterCommonLogic(true);
    } else {
      latestFilteredItems = this.filterCommonLogic(false);
    }

    if (!this.noFilter) {
      latestFilteredItems = this.sortArrayByOriginalOrder(this.serviceData, latestFilteredItems);
    }

    this.panelList.lists = this.noFilter ? this.serviceData : latestFilteredItems;

    // Below method is used to check for checkbox selections
    if (this.panelList.enableSelection) {
      this.updateParentSelection();
    }
    if(filterColumn !==null && index !== null)
      this.updateFiltersOfPanelList(filterColumn, index);

  }
  
  sortArrayByOriginalOrder(serviceData: any, latestFilteredItems: any) {
    return latestFilteredItems.sort((a: any, b: any) => {
      const indexA = serviceData.findIndex((item: any) => JSON.stringify(item) === JSON.stringify(a));
      const indexB = serviceData.findIndex((item: any) => JSON.stringify(item) === JSON.stringify(b));
      return indexA - indexB;
    });
  };

  filterCommonLogic(filteringData: boolean) {
    let filteredItems: any[] = [];
    let latestFilteredItems: any[] = [];
    let i = 0, j = 0;
    for (let selectedFilterItem of this.selectedFilterItems) {
      if (selectedFilterItem != undefined && selectedFilterItem.length > 0) {
        this.noFilter = false;
        let filterColumnName: string;
        i > this.filterItems.length - 1 ? filterColumnName = this.additionalFilters[i - this.standardFilterCount].column : filterColumnName = this.filterItems[i].column;
        let filteredDataItem: any[];
        if (filteringData)
          filteredItems = [];
        selectedFilterItem.forEach((filterValue) => {
          if (latestFilteredItems.length && j > 0)
            filteredDataItem = latestFilteredItems.filter(
              (item: { [x: string]: any }) =>
                item[filterColumnName] instanceof Array
                  ? item[filterColumnName].indexOf(filterValue) > -1
                  : item[filterColumnName] === filterValue
            );
          else if ((filteringData == true && j == 0) || filteringData == false)
            filteredDataItem = this.serviceData.filter(
              (item: { [x: string]: any }) =>
                item[filterColumnName] instanceof Array
                  ? item[filterColumnName].indexOf(filterValue) > -1
                  : item[filterColumnName] === filterValue
            );

          filteredDataItem?.forEach((filterData) => {
            if (filteredItems.indexOf(filterData) == -1)
              filteredItems.push(filterData);
          });
        });
        j++;
      }
      i++

      if (filteringData) {
        latestFilteredItems = [...filteredItems];
      } else {
        if (filteredItems.length) {
          latestFilteredItems = [...filteredItems];
          filteredItems = [];
        }
      }
    }

    // If the filter data is present in DB, send the filtered data
    if (latestFilteredItems != undefined && latestFilteredItems.length > 0){
      latestFilteredItems = this.keywordFilter(latestFilteredItems);
    }
    // If the there is no filter, i.e., while using keyword filter or removing selected filter - return full list data
    else if(filteringData == false || (filteringData && this.selectedFilterItems.length >= 0)){
      // If all the items are empty return full list else empty List
      for(let i = 0; i < this.selectedFilterItems.length; i++){
        if(this.selectedFilterItems[i] !== undefined && this.selectedFilterItems[i].length > 0){
          latestFilteredItems = this.keywordFilter([]);
          return latestFilteredItems;
        }
      }
      latestFilteredItems = this.keywordFilter(this.serviceData);
    }
    else // else sending empty list to display
      latestFilteredItems = this.keywordFilter([]); 
      
    return latestFilteredItems;
  }

  keywordFilter(latestFilteredItems: any) {
    let items: ({ [s: string]: unknown } | ArrayLike<unknown>)[] = [];
    if (this.filterKey !== null && this.filterKey !== '') {
      latestFilteredItems.forEach(
        (item: { [s: string]: unknown } | ArrayLike<unknown>) => {
          for (let value of Object.entries(item)) {
            if (
              String(value).toLowerCase().includes(this.filterKey.toLowerCase())
            ) {
              items.push(item);
              break;
            }
          }
        }
      );
      latestFilteredItems = items;
    }
    return latestFilteredItems;
  }

  sortDataBy(sortDirection: string, sortByField: any) {
    if (sortByField === 'requestedEffectiveDate' || sortByField === 'effectiveDate') {
      this.panelList.lists = this.panelList.lists.sort((a: { [x: string]: any }, b: { [x: string]: any }) => {
        const aValue = a[sortByField];
        const bValue = b[sortByField];
  
        const aPhaseMatches = this.PhaseCheckForEffectiveDatesSort(a['phase'], sortByField);
        const bPhaseMatches = this.PhaseCheckForEffectiveDatesSort(b['phase'], sortByField);
  
        if (aPhaseMatches && bPhaseMatches) {
          // Both a and b has phases matching with requetEffective date phases andeffective date phases list
          if (aValue === null || aValue === undefined) return 1;
          if (bValue === null || bValue === undefined) return -1;
  
          if (sortDirection === 'Ascending') {
            return aValue > bValue ? 1 : (aValue < bValue ? -1 : 0);
          } else {
            return aValue < bValue ? 1 : (aValue > bValue ? -1 : 0);
          }
          //Only if a phase matches with requetEffective date phases
        } else if (aPhaseMatches) {
          return -1;
        //Only if b phase matches with Effective date phases
        } else if (bPhaseMatches) {
          return 1;
        } else {
          return 0;
        }
      });
    }
    else{
    this.panelList.lists = this.panelList.lists.sort((a: { [x: string]: string }, b: { [x: string]: any }) => {
      const aValue = a[sortByField];
      const bValue = b[sortByField];
  
      //Below If is used to push the null to the end of the list
      if (aValue === null || aValue === undefined) return 1; 
      if (bValue === null || bValue === undefined) return -1;
  
      if (sortDirection === 'Ascending') {
        return aValue > bValue ? 1 : (aValue < bValue ? -1 : 0);
      } else {
        return aValue < bValue ? 1 : (aValue > bValue ? -1 : 0);
      }
    });
  }
  }
  
  PhaseCheckForEffectiveDatesSort(phase: any, field: string): boolean {
    const numericPhase = parseInt(phase, 10);
    if (field === 'requestedEffectiveDate') {
      return PanelListConstants.RequestedEffectiveDatePhases.includes(numericPhase);
    } else if (field === 'effectiveDate') {
      return PanelListConstants.EffectiveDatePhases.includes(numericPhase);
    }
    return false;
  }


  clearFilter(filterColumn: string, index: number) {
    this.selectedFilterItems[index] = [];
    this.applyFilter(filterColumn, index);
    this.unselectSelectAllAndRetainSelection();

    // Below method is used to check for checkbox selections
    if (this.panelList.enableSelection) {
      this.updateParentSelection();
    }
  }

  clearAllFilters() {
    this.filterKey = null;
    for (let i = 0; i < this.selectedFilterItems.length; i++) {
      this.selectedFilterItems[i] = [];
    }
    this.panelList.lists = this.serviceData;
    this.unselectSelectAllAndRetainSelection();

    // Below method is used to check for checkbox selections
    if (this.panelList.enableSelection) {
      this.updateParentSelection();
    }
    this.filterAndSortDetails.filterDetails = [];
  }

  selectItemsChange(item: any, originEvent: any, index: number) {
    if (
      originEvent.checked !== undefined &&
      originEvent.checked !== null &&
      originEvent.checked
    ) {
      if (this.selectedCards.indexOf(item) < 0) {
        item.isChecked = true;
        this.selectedCards.push(item);
      }

      //Below code is for Parent checkbox selection/un selection to work
      this.panelList.lists.some((element: any) => { if (JSON.stringify(element) === JSON.stringify(item)) element.isChecked = true });

      this.selectAll[index] = true;
    } else {
      this.selectedCards.forEach((element: any, index: any) => {
        if (element === item) {
          item.isChecked = false;
          this.selectedCards.splice(index, 1);
        }
      });

      //Below code is for Parent checkbox selection/un selection to work
      this.panelList.lists.some((element: any) => { if (JSON.stringify(element) === JSON.stringify(item)) element.isChecked = false });

      this.selectAll[index] = false;
    }
    this.selectedItems.emit(this.selectedCards);

    // Below method is used to check for checkbox selections
    if (this.panelList.enableSelection) {
      this.updateParentSelection();
    }
  }

  selectDeselectAll(originEvent: any) {
    if (originEvent.checked) {
      this.isSelectAllCheckBox = true;
      this.panelList.lists.forEach((element: any) => {
        if (this.panelList.isCheckBoxContainsDisable) {
          if (element.isActive === 'Yes') {
            element.isChecked = true;
            this.selectedCards.push(element);
          }
        } else {
          element.isChecked = true;
          this.selectedCards.push(element);
        }
      });
    } else {
      this.panelList.lists.forEach((element: any) => { element.isChecked = false; });
      this.selectedCards = [];
      this.isSelectAllCheckBox = false;
    }
    this.selectedItems.emit(this.selectedCards);


    // Below method is used to check for checkbox selections
    if (this.panelList.enableSelection) {
      this.updateParentSelection();
    }
  }

  //Below method is used to check for  parent checkbox selection
  updateParentSelection() {
    if (!!this.panelList.lists.length) {
      const allSelected = this.panelList.lists.every((obj: any) => obj.isChecked);
      const someSelected = this.panelList.lists.some((obj: any) => obj.isChecked);
      this.parentSelection = allSelected ? true : (someSelected ? false : false);
      this.isSelectAllDisabled = false;
    } else {
      this.parentSelection = false;
      this.isSelectAllDisabled = true;
    }
  }

  unselectSelectAllAndRetainSelection() {
    if (this.selectAll.length > 0) {
      this.selectAll = [];
      //select only the ones selected
      this.selectedCards.forEach((selectedItem: any) => {
        let index = this.panelList.lists.indexOf(selectedItem);
        let checkedItem = [];
        checkedItem.push(true);
        let originEvent = {
          checked: checkedItem,
        };
        this.selectItemsChange(selectedItem, originEvent, index);
      });
    }
  }

  expandAll() {
    this.panelList.lists.forEach((item: any) => item.collapsed = false);
  }
  collapseAll() {
    this.panelList.lists.forEach((item: any) => item.collapsed = true);
  }

  populateMoreFilters() {
    this.moreFilters = false;
    this.hideFilters = true;
    if (this.allFilters.length > this.standardFilterCount) {
      this.populateAfterClickOnMoreFilter = true;
    }
  }
  hideShownFilters() {
    this.moreFilters = true;
    this.hideFilters = false;
    this.populateAfterClickOnMoreFilter = false;
  }

  checkForDisable(item: any): boolean {
    let isCheckBoxDisable: boolean = false;
    if (this.panelList.isCheckBoxContainsDisable && item?.isActive === 'No')
      isCheckBoxDisable = true;
    else if (this.panelList.selectedChangeRequestItemType) {
      this.panelList.selectedChangeRequestItemType ===
        item.changeRequestItemType
        ? (isCheckBoxDisable = false)
        : (isCheckBoxDisable = true);
    }
    return isCheckBoxDisable;
  }

  getToolTipForDisabledCheckBox(item: any): string {
    if (this.panelList.selectedChangeRequestItemType) {
      if (
        this.panelList.selectedChangeRequestItemType ===
        item.changeRequestItemType
      ) {
        return MessageConstants.BlankToolTipConstant;
      } else {
        return MessageConstants.DisabledCheckBoxConstantForCRIItems;
      }
    }
    return MessageConstants.BlankToolTipConstant;
  }

  getSelecteditems(item: any, i: number): boolean {
    if (this.panelList.isCheckBoxContainsDisable && this.isSelectAllCheckBox) {
      let isChecked: boolean;

      this.selectedCards?.some(
        (obj: any) => obj.documentNumber != item.documentNumber
      )
        ? (isChecked = false)
        : item.isActive === 'Yes'
          ? (isChecked = true)
          : (isChecked = false);

      return isChecked;
    } else {
      var isChecked = false;
      if (this.selectedCards?.length) {
        this.selectedCards.some(
          (obj: any) => JSON.stringify(obj) === JSON.stringify(item)
        )
          ? (isChecked = true)
          : (isChecked = false);
      }
      return isChecked;
    }
  }
  setSelectAllCheckBox() {
    if (
      this.panelList.lists.some(
        (x: any) =>
          x.changeRequestItemType ===
          ChangeRequestConstants.ManualChangeRequestItemType
      ) &&
      this.panelList.lists.some(
        (x: any) =>
          x.changeRequestItemType ===
          ChangeRequestConstants.PeriodicReviewChangeRequestItemType
      )
    ) {
      this.isSelectAllDisabled = true;
    } else this.isSelectAllDisabled = false;
  }

  getFiltersData() {
    this.filterItems = [];
    if (this.panelList.enableFilter) {
      for (let filter of this.panelList.filters!) {
        let filterItem = {
          name: filter.filterDisplayName,
          options: [
            ...new Set(
              this.panelList.lists.map(
                (l: { [x: string]: any }) => l[filter.filterFieldName]
              )
            ),
          ],
          column: filter.filterFieldName,
        };

        let options: unknown[] = [];
        filterItem.options = [
          ...new Set(filterItem.options.flatMap((obj) => obj)),
        ];
        filterItem.options.forEach((f) => {
          if (f !== undefined && f !== null && f !== '') {
            options.push({
              name: f,
              value: f,
            });
          }
        });
        filterItem.options = options;
        this.filterItems.push(filterItem);
      }
    }
  }

  getAdditionalFiltersData() {
    this.allFilters = this.filterItems;
    let standardfilterList = this.filterItems.slice(
      0,
      this.standardFilterCount
    );

    if (this.filterItems.length > this.standardFilterCount) {
      this.additionalFilters = this.filterItems;
      this.filterItemsCount = this.standardFilterCount;
      this.moreFilters = true;
      this.isMoreFilters = true;
      this.filterItems = standardfilterList;
      this.additionalFilters = this.additionalFilters.slice(
        this.standardFilterCount,
        this.allFilters.length + 1
      );
    }
  }

  getSortData() {
    let sortOptions: MenuItem[] = [];
    if (this.panelList.enableSort) {
      for (let sortOption of this.panelList.sort!) {
        sortOptions.push({
          label: sortOption.sortFieldDisplayName,
          items: [
            {
              label: 'Ascending',
              icon: 'pi pi-sort-alpha-up',
              command: (event: any) => {
                this.sortDataBy(event.item.label, sortOption.sortFieldName);
              },
              style: { float: 'left' },
            },
            {
              label: 'Descending',
              icon: 'pi pi-sort-alpha-down-alt',
              command: (event: any) => {
                this.sortDataBy(event.item.label, sortOption.sortFieldName);
              },
              style: { float: 'left' },
            },
          ],
          style: { 'margin-left': 'auto' },
        });
      }
      this.sortItems.push({ label: 'Sort By', items: sortOptions });
    }
  }

  getPanelToggleCondition() {
    if (this.panelList.enableToggling == true) {
      this.isCardToggleable = true;
      this.panelList.lists.forEach((item: any) => item.collapsed = true);
    } else {
      this.isCardToggleable = false;
    }
  }
  onPanelCardClick = (item: any, index: number) => {
    if (this.panelList.enablePanelCardClick) {
      this.panelCardClickEvent.emit(item);
      if (this.panelList.enablePanelHighLight) {
        this.activeIndex = index
      };
    }
  }

  exportDataToExcel(){
    this.exportExcelEvent.emit();
  }

  updateFiltersOfPanelList = (filterColumn:string,index:number) => {
   let filterColumnIndex = this.filterAndSortDetails.filterDetails.findIndex(i=>i.fieldName === filterColumn);
   if(filterColumnIndex === -1){
    this.filterAndSortDetails.filterDetails.push({
      fieldName : filterColumn,
      fieldValues : this.selectedFilterItems[index]
    })
   }else {
     if(this.selectedFilterItems[index] != undefined 
      && this.selectedFilterItems[index].length > 0) {
        this.filterAndSortDetails.filterDetails[filterColumnIndex].fieldValues = this.selectedFilterItems[index];
     }else{
      this.filterAndSortDetails.filterDetails.splice(filterColumnIndex, 1);
     }
   }
  }

  getFiltersAndSortDetails = () : FilterAndSortDetails => {
    this.filterAndSortDetails.searchText = this.filterKey;
    return this.filterAndSortDetails;

  }

  getDefaultFilterAndSortDetails = () : FilterAndSortDetails => {
    return {
      searchText: '',
      filterDetails:[],
      sortDetails:[],
      puid:null,
      isShowAll :false
    }
  }

}
